<template>

	<el-input
		ref="input"
		class="input-sigarus-textarea"
		type="textarea"
		rows="4"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
	/>

</template>

<script>
	export default {
		name: 'InputSigarusTextarea',
		props: {
			value: {
				default: ''
			}
		},
		computed: {

			model: {

				get () { return this.value },

				set (val) { this.$emit('input', val) }

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			select () { setTimeout(() => this.$refs.input.select(), 200) }
		}
	}
</script>

<style lang="scss">
textarea {
	border-radius: 0px!important;
}
</style>
